import { Project } from "interfaces";

import { projectIsDriverAnalysis } from "flows/driver-analysis/interfaces";
import DriverAnalysisSummary from "flows/driver-analysis/elements/Context-Summary";

import { projectIsTimeSeriesAnalysis } from "flows/time-series/interfaces";
import TimeSeriesSummary from "flows/time-series/elements/Context-Summary";

import { projectIsClusteringAnalysis } from "flows/clustering/interfaces";
import ClusteringAnalysisSummary from "flows/clustering/elements/Context-Summary";

import { projectIsNotebookAnalysis } from "flows/notebook-analysis/interfaces";
import NotebookAnalysisSummary from "flows/notebook-analysis/elements/Context-Summary";

import { projectIsTextMining } from "flows/text-mining/interfaces";
import TextMiningSummary from "flows/text-mining/elements/Context-Summary";

import { projectIsForecastingAnalysis } from "flows/forecasting/interfaces";
import ForecastingProjectSummary from "flows/forecasting/elements/Context-Summary";

import { projectIsImpactAnalysisContinous } from "flows/impact-analysis-continous/interfaces";
import ImpactAnalysisContinousProjectSummary from "flows/impact-analysis-continous/elements/Context-Summary";

import { projectIsImpactAnalysisBinary } from "flows/impact-analysis-binary/interfaces";
import ImpactAnalysisBinaryProjectSummary from "flows/impact-analysis-binary/elements/Context-Summary";

import { projectIsProfileDiscovery } from "flows/profile-discovery/interfaces";
import ProfileDiscoveryProjectSummary from "flows/profile-discovery/elements/Context-Summary";

import { projectIsMarketMixModelling } from "flows/market-mix-modelling/interfaces";
import MarketMixProjectSummary from "flows/market-mix-modelling/elements/Context-Summary";

import { projectIsETAEstimator } from "flows/eta-estimator/interfaces";
import ETAProjectSummary from "flows/eta-estimator/elements/Context-Summary";

import { projectIsNetworkFailureAnalysis } from "flows/network-failure-analysis/interfaces";
import NetworkFailuresProjectSummary from "flows/network-failure-analysis/elements/Context-Summary";

import { projectIsSalesEffectiveness } from "flows/sales-effectiveness/interfaces";
import SalesEffectivenessProjectSummary from "flows/sales-effectiveness/elements/Context-Summary";

const ContextSummary = ({ project }: { project: Project }) => {
  if (projectIsDriverAnalysis(project)) {
    return <DriverAnalysisSummary project={project} />;
  }
  if (projectIsSalesEffectiveness(project)) {
    return <SalesEffectivenessProjectSummary project={project} />;
  }
  if (projectIsTimeSeriesAnalysis(project)) {
    return <TimeSeriesSummary project={project} />;
  }
  if (projectIsClusteringAnalysis(project)) {
    return <ClusteringAnalysisSummary project={project} />;
  }
  if (projectIsNotebookAnalysis(project)) {
    return <NotebookAnalysisSummary project={project} />;
  }
  if (projectIsTextMining(project)) {
    return <TextMiningSummary project={project} />;
  }
  if (projectIsForecastingAnalysis(project)) {
    return <ForecastingProjectSummary project={project} />;
  }
  if (projectIsProfileDiscovery(project)) {
    return <ProfileDiscoveryProjectSummary project={project} />;
  }
  if (projectIsImpactAnalysisContinous(project)) {
    return <ImpactAnalysisContinousProjectSummary project={project} />;
  }
  if (projectIsImpactAnalysisBinary(project)) {
    return <ImpactAnalysisBinaryProjectSummary project={project} />;
  }
  if (projectIsMarketMixModelling(project)) {
    return <MarketMixProjectSummary project={project} />;
  }
  if (projectIsETAEstimator(project)) {
    return <ETAProjectSummary project={project} />;
  }
  if (projectIsNetworkFailureAnalysis(project)) {
    return <NetworkFailuresProjectSummary project={project} />;
  }
  return null;
};

export default ContextSummary;
